<template>
  <CSidebar class="pretest-sidebar" position="fixed" :visible="true">
    <div class="brand">
      <CSidebarBrand>
        <img src="@/assets/images/logo-black.svg" />
      </CSidebarBrand>
    </div>
    <div class="side-button">
      <button
        v-for="item in questionnaireOptions"
        :key="item"
        :style="
          $route.path === `/questionnaire/${questionnaireId}/${item.part_id}`
            ? 'background: #D1E5EF'
            : 'background: #f3f8fb'
        "
        @click="pushRouter(item.part_id)"
        class="border-0 btn mt-2 mx-auto text-dark edit-options-btn position-relative d-flex justify-content-between align-items-center"
      >
        <span> {{ item.title }}</span>
        <div>
          {{searchFinishData(item.part_id)[0]}}/{{searchFinishData(item.part_id)[1] }}
        </div>
      </button>
    </div>
      <router-link to="/contact" class="message">
        <img src="@/assets/icons/message.svg" />
        聯繫我們
      </router-link>
      <div @click="setSignOut" class="sign-out">
        <img src="@/assets/icons/logout.svg" />
        登出
      </div>
  </CSidebar>
  <MsgBox :show="showMsgBox" :errorMsg="errorMsg" @close="showMsgBox = false" />
</template>

<script>
import { signOut } from '@/api/Info'
import { useRouter } from 'vue-router'
import MsgBox from '@/components/MsgBox.vue'
import { ref } from 'vue'
import { ItemTypes } from '../../defines'
export default {
  name: 'PreTestSidebar',
  components: {
    MsgBox,
  },
  props: {
    questionnaireOptions: {
      type: Array,
      default: () => [],
    },
    questionnaireId: {
      type: [String, Number],
      default: null,
    },
    finishCount:{
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const router = useRouter()
    const searchFinishData = (id)=>{
      if(id && props.finishCount.length){
        const item = props.finishCount.find(e=>e.part_id === id)
        if(item.done_count+item.undone_count+item.unknown_count === 0){
          const item = props.questionnaireOptions.find(e=>e.part_id === id)
          const _arr =  item?.items || [];
          // 排除引言
          const length = _arr.filter((i) => i.type !=="Introduction").length;
          return [0, length || 0]
        }else{
          return [item.done_count, item.done_count+item.undone_count+item.unknown_count]
        }
      }else{
        const item = props.questionnaireOptions.find(e=>e.part_id === id)
        let count = 0
        item.items.forEach(e=>{
          if(e.type !== ItemTypes.Introduction){
            count += 1
          }
        })
        return [0, count]
      }
    }
    const pushRouter = (id)=>{
      router.push(`/questionnaire/${props.questionnaireId}/${id}`)
    }
    const setSignOut = async () => {
      const state = await signOut()
      if(!state.error){
        showMsgBox.value = true
        errorMsg.value = '登出成功'
        setTimeout(()=>{
          router.push('/')
        },1000)
      }else{
        showMsgBox.value = true
        errorMsg.value = state.msg
      }
    }
    return {
      searchFinishData,
      setSignOut,
      signOut,
      showMsgBox,
      errorMsg,
      errorCode,
      pushRouter
    }
  },
}
</script>

<style lang="scss" scoped>
:global(.pretest-sidebar) {
  --cui-sidebar-brand-bg: none;
  --cui-sidebar-color: #4d4d4d;
  border-radius: 0 20px 20px 0;
  border: 1px solid #eff0f6;
  background: #ffffff;
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.05));
}
.brand {
  padding: 24px 0;
  img {
    width: 120px;
  }
}
.content-wrapper {
  padding: 0 25px;
}
.selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 10px 16px;
  gap: 10px;
  margin-bottom: 35px;
  background: #f3f8fb;
  border-radius: 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #187baf;
}
.link {
  display: block;
  margin-bottom: 40px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #4d4d4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}
.edit-options-btn {
  font-size: 14px;
  width: 192px;
  height: 48px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #177baf;
  border-radius: 4px;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.message {
  position: absolute;
  bottom: 6rem;
  left: 3.5rem;
  color: #177baf;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  img {
    margin-right: 10px;
  }
}
.sign-out{
  position: absolute;
  bottom: 3rem;
  left: 3.5rem;
  color: #177baf;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  img {
    width: 18px;
    margin-right: 10px;
  }
}
.side-button{
  height: calc(100vh - 200px);
  overflow-y: scroll;
  padding-bottom: 30px;
}
</style>
